import customaxios from ".";

export const getServices = (typeOfService: string) => {
  return customaxios({
    method: "GET",
    url: `/services`,
    params: {
      type: typeOfService,
    },
  });
};

export const getSearchResults = (query: string) => {
  return customaxios({
    method: "GET",
    url: `/search`,
    params: {
      text: query,
    },
  });
};

export const getTopProviderAndPlanar = (params: any) => {
  return customaxios({
    method: "GET",
    url: "/search/top-content",
    params
  });
};

export const subscribeNewsLetter = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/newsletter/subscribe`,
    data,
  });
};